"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Module_1 = require("./Module");
var Connection_1 = require("./Connection");
var Block_1 = require("./Block");
var Media_1 = require("./Media");
var Theme_1 = require("./Theme");
var FontFamily_1 = require("./FontFamily");
var Client = /** @class */ (function () {
    function Client(base) {
        this.connection = new Connection_1.Connection(base);
        this.module = Module_1.CreateModuleEndpoint({ connection: this.connection });
        this.blocks = Block_1.CreateBlockEndpoint({ connection: this.connection });
        this.files = Media_1.CreateFileEndpoint({ connection: this.connection });
        this.themes = Theme_1.CreateThemeEndpoint({ connection: this.connection });
        this.fonts = FontFamily_1.CreateFontFamilyEndpoint({ connection: this.connection });
    }
    return Client;
}());
exports.Client = Client;
